// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2bWvj";
export var contentContainer = "styles-module--contentContainer--3xhe5";
export var wysiwyg = "styles-module--wysiwyg--1Cjgw";
export var imageContainer = "styles-module--imageContainer--gifdK";
export var open = "styles-module--open--ifuup";
export var close = "styles-module--close--lRVtx";